import styled from 'styled-components'

export interface FilterOption {
  label: string
  value: string
}

interface FilterButtonsProps {
  filters: FilterOption[]
  activeFilter: string
  onFilterChange: (filter: string) => void
}

export const FilterButtons = ({ filters, activeFilter, onFilterChange }: FilterButtonsProps) => {
  return (
    <SFiltersRow>
      {filters.map(f => (
        <SFilterButton
          key={f.value}
          $active={activeFilter === f.value}
          onClick={() => onFilterChange(f.value)}
        >
          {f.label}
        </SFilterButton>
      ))}
    </SFiltersRow>
  )
}

const SFiltersRow = styled.div`
  display: flex;
  gap: 8px;
`

const SFilterButton = styled.button<{ $active: boolean }>`
  padding: 5px 16px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid ${({ $active }) => ($active ? '#8747DF' : '#D9D9D9')};
  background: ${({ $active }) => ($active ? '#eceafe' : 'rgba(0, 0, 0, 0.02)')};
  color: ${({ $active }) => ($active ? '#8747DF' : 'rgba(0, 0, 0, 0.88)')};
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s;
  height: 32px;
  border-radius: 6px;
  &:hover {
    background: #eceafe;
  }
`
